export default __webpack_public_path__ + "static/media/Golden galaxy_primary.99f764b3.jpg";